<template>
  <appTable
    v-if="shouldRenderConfig"
    :tableName="name"
    :tableClass="getClassName"
  >
    <slot></slot>
  </appTable>
</template>
<script>
export default {
  computed: {
    name: () => {
      return "Customer Notes";
    }
  }
};
</script>
